import { format, parseISO } from 'date-fns'
import { toZonedTime } from 'date-fns-tz'

const TZ = 'Europe/Helsinki'

export function formatDateTimeLocal(utcIso: string): string {
  return format(toZonedTime(parseISO(utcIso), TZ), 'dd.MM.yyyy HH:mm')
}

export function formatDateLocal(utcIso: string): string {
  return format(toZonedTime(parseISO(utcIso), TZ), 'dd.MM.yyyy')
}

export function formatEur(eur: number | null | undefined): string {
  if (eur == null) return '–'
  return eur.toLocaleString('fi-FI', { style: 'currency', currency: 'EUR', minimumFractionDigits: 2, maximumFractionDigits: 4 })
}

export function formatKwh(kwh: number): string {
  return `${kwh.toLocaleString('fi-FI', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} kWh`
}

export function formatSntKwh(snt: number): string {
  return `${snt.toLocaleString('fi-FI', { minimumFractionDigits: 1, maximumFractionDigits: 2 })} snt/kWh`
}
